const millSizes = [
  { name: '3.175mm (1/8インチ)', value: 3.175 },
  { name: '6mm', value: 6.0 },
  { name: '6.35mm (1/4インチ)', value: 6.35 },
  { name: '8mm', value: 8.0 },
  { name: '12mm', value: 12.0 },
  { name: '12.7mm (1/2インチ)', value: 12.7 }
];

const machines = [
  {
    id: "rps-alpha-standard-36",
    name: 'PRS Alpha/Standard/Saburoku',
    img: 'shopbot-prs-alpha.png',
    bedWidth: 1820,
    bedDepth: 910,
    rotationSpeed: 18000,
    xySpeed: 60,
    zSpeed: 25,
    jogSpeed: 250,
  },
  { id: "desktop-max",
    name: 'Desktop MAX',
    img: 'shopbot-desktop-max.png',
    bedWidth: 965,
    bedDepth: 635,
    rotationSpeed: 15000,
    xySpeed: 50,
    zSpeed: 25,
    jogSpeed: 100,
  },
  { id: "desktop",
    name: 'Desktop',
    img: 'shopbot-desktop.png',
    bedWidth: 640,
    bedDepth: 508,
    rotationSpeed: 15000,
    xySpeed: 50,
    zSpeed: 25,
    jogSpeed: 100,
  }
];

const getClearance = (millSize = 6.35) => {
  let part; // 部材の余白
  if (millSize >= 12.7) {
    part = 25;
  } else {
    part = 15;
  }
  const delta = 1.5;
  //const bin = 5 - delta; // 板4辺の余白
  const bin = 5; // emarf_cam のチェック方法に合わせる　(sheet_clearance)
  const partDelta = part + delta;
  return { bin, part, partDelta };
};

const getClearanceFromThickness = (thickness = 24) => {
  const millSize = getMillSizeFromThickness(thickness);
  return getClearance(millSize);
};

const getMillSizeFromThickness = (thickness = 24) => {
  return thickness < 30 ? 6.35 : 12.7;
};

const getTabSize = (thickness) => {
  let width;
  let height;
  if (thickness <= 5) {
    width = 5
    height = 1
  } else if (thickness <= 9) {
    width = 12
    height = 6
  } else if (thickness <= 18) {
    width = 8
    height = 8
  } else if (thickness <= 24) {
    width = 10
    height = 8
  } else {
    width = 12
    height = 8
  }
  return { width, height };
};

const Emarf = (app, options) => {
  const { host } = location;

  const query = new URLSearchParams(location.search);
  const isLabMode = Boolean(query.get('lab'));

  const isProd = (
    (host === 'my.emarf.co') ||
    (options.emarfEnv === 'prod')
  );
  const isExperiment = (
    isLabMode ||
    (host === 'lab.emarf.co') ||
    (options.emarfEnv === 'experiment')
  );
  const isViewer = (
    host.endsWith('viewer.emarf.co') ||
    (options.emarfEnv === 'viewer')
  );
  const cwConfig = options['cloudwatch'] ? options.cloudwatch : {};

  app.prototype.$emarf = {
    isProd,
    isExperiment,
    isViewer,
    millSizes,
    machines,
    getClearance,
    getClearanceFromThickness,
    getMillSizeFromThickness,
    getTabSize,
    cwConfig
  };
};

export {
  Emarf,
  getClearanceFromThickness,
  getMillSizeFromThickness,
  getTabSize
};



// WEBPACK FOOTER //
// ./src/plugins/emarf.js